import PerfectScrollbar from 'perfect-scrollbar'

const resetScroll = (ctx, selector) => {
  ctx.$el.querySelector(selector).scrollLeft = 0
  ctx.$el.querySelector(selector).scrollTop = 0
  ctx.ps.update(ctx.$el.querySelector(selector))
}

export const initScrollbar = (ctx, selector) => {
  const viewport = ctx.$el.querySelector(selector)
  if (ctx.ps && !ctx.ps.isAlive) {
    ctx.ps.destroy()
    ctx.ps = null
    ctx.ps = new PerfectScrollbar(viewport, {
      minScrollbarLength: 20
    })
  } else if (ctx.ps) resetScroll(ctx, selector)
  else {
    ctx.ps = new PerfectScrollbar(viewport, {
      minScrollbarLength: 20
    })
  }
  viewport.addEventListener('wheel', e => {
    // viewport.scrollTop += e.deltaY
    e.preventDefault()
  })
}



// WEBPACK FOOTER //
// ./src/components/_modules/Dashboard/helpers/scrollbarHelper.js